<template>
  <t-default-layout active-nav-id="home-sub-banner">
    <div :class="componentClassName">
      <a-back-page :id="id" :text="backPageName()" :page="backPage()" :show="show" />
      <form
        ref="form"
        class="t-home-sub-banner-edit__form"
        enctype="multipart/form-data"
        @submit.prevent="handleFormSubmit"
      >
        <div class="t-home-sub-banner-edit__fields">
          <m-section>
            <div class="t-home-sub-banner-edit__tabgroup">
              <ul class="t-home-sub-banner-edit__tabnav">
                <li
                  data-testid="new-home-sub-banner-display-button"
                  :class="{ selected: activeTab === 'new' }"
                  @click="activeTab = 'new'"
                >
                  リニューアル後（新小バナー）
                </li>
                <li
                  data-testid="old-home-sub-banner-display-button"
                  :class="{ selected: activeTab === 'old' }"
                  @click="activeTab = 'old'"
                >
                  リニューアル前（旧小バナー）
                </li>
              </ul>

              <!-- 詳細設定（新旧統合） -->
              <m-action-card
                :id="idName[1]"
                test-id-text="edit-home-sub-banner"
                title="詳細設定"
                :document-id="id"
                header-border
                no-header-margin
                icon="clock"
              >
                <!-- 共通：フラグ設定エリア -->
                <div class="t-home-sub-banner-edit__row1">
                  <m-form-input
                    id="t-home-sub-banner-edit-dAccountLoginFlag__form-input"
                    class="t-home-sub-banner-edit__flag-row"
                  >
                    <a-text
                      id="t-home-sub-banner-edit-dAccountLoginFlag__a-text"
                      class="t-home-sub-banner-edit__label-with-indent"
                      weight="bold"
                      >ビジネスｄアカウントログイン</a-text
                    >
                    <a-switch
                      id="t-home-sub-banner-edit-dAccountLoginFlag"
                      v-model="homeSubBannerData.dAccountLoginFlag"
                      class="t-home-sub-banner-edit__switch-label"
                      data-testid="edit-news-and-seminar-priority-toggle-button"
                    />
                  </m-form-input>
                </div>
                <div class="t-home-sub-banner-edit__row1">
                  <m-form-input
                    id="t-home-sub-banner-edit-webviewFlag__form-input"
                    class="t-home-sub-banner-edit__flag-row"
                  >
                    <a-text
                      id="t-home-sub-banner-edit-webviewFlag__a-text"
                      class="t-home-sub-banner-edit__label-with-indent"
                      weight="bold"
                      >Webビュー</a-text
                    >
                    <a-switch
                      id="t-home-sub-banner-edit-webviewFlag"
                      v-model="homeSubBannerData.webviewFlag"
                      class="t-home-sub-banner-edit__switch-label"
                      data-testid="edit-news-and-seminar-priority-toggle-button"
                    />
                  </m-form-input>
                </div>
                <div class="t-home-sub-banner-edit__row1">
                  <m-form-input
                    id="t-home-sub-banner-edit-notificationPromptFlag__form-input"
                    class="t-home-sub-banner-edit__flag-row"
                  >
                    <a-text
                      id="t-home-sub-banner-edit-notificationPromptFlag__a-text"
                      class="t-home-sub-banner-edit__label-with-indent"
                      weight="bold"
                      >通知許可フラグ</a-text
                    >
                    <div class="t-home-sub-banner-edit__flag-control">
                      <a-switch
                        id="t-home-sub-banner-edit-notificationPromptFlag"
                        v-model="homeSubBannerData.notificationPromptFlag"
                        class="t-home-sub-banner-edit__switch-label"
                        data-testid="edit-home-sub-banner-notificationPromptFlag"
                      />
                      <a-text id="t-home-sub-banner-edit-notificationPromptFlag__a-text-notice" class="t-home-sub-banner-edit__flag-control__notice">
                        ※プッシュ通知未許可ユーザーにポップアップを表示します
                      </a-text>
                    </div>
                  </m-form-input>
                </div>
                <!-- 差分：画像・テキスト入力エリア -->
                <div class="t-home-sub-banner-edit__fields">
                  <div
                    v-show="activeTab === 'new'"
                    id="t-home-sub-banner-edit-uploading-file-new"
                    class="t-home-sub-banner-edit__row t-home-sub-banner-edit__image-upload-area t-home-sub-banner-edit__row--square"
                  >
                    <div class="t-home-sub-banner-edit__col-1">
                      <m-form-input>
                        <a-upload-field
                          id="upload-image-new"
                          v-model="homeSubBannerData.newImageFile.file"
                          test-id-text="edit-home-sub-banner-image-new"
                          name="imageFile"
                          class="t-home-sub-banner-edit-uploading-file__form-upload"
                          label="ファイルをドラッグ＆ドロップするかパソコンからファイルを貼り付けしてください。"
                          accept="image/png, image/jpg, image/jpeg"
                          @change="handleUploadFileChange('newImageFile', $event)"
                          @show-error-modal="showErrorModal"
                        />
                      </m-form-input>
                    </div>
                    <div class="t-home-sub-banner-edit__col-2">
                      <a-text class="t-home-sub-banner-edit__text-field-label" weight="bold">タイトル</a-text>
                      <m-form-input>
                        <a-apply-text-field
                          id="title-new"
                          v-model="homeSubBannerData.newTitle"
                          data-testid="edit-home-sub-banner-title-input-new"
                          type="text"
                          maxlength="19"
                          maxlength-id="t-home-sub-banner-edit-title-maxlength-new"
                          placeholder="タイトル入力"
                        />
                      </m-form-input>
                      <a-text class="t-home-sub-banner-edit__text-field-label" weight="bold">補足説明</a-text>
                      <m-form-input>
                        <a-apply-text-field
                          id="description"
                          v-model="homeSubBannerData.newDescription"
                          data-testid="edit-home-sub-banner-description-input"
                          type="text"
                          maxlength="22"
                          maxlength-id="t-home-sub-banner-edit-description-maxlength"
                          placeholder="説明文入力"
                        />
                      </m-form-input>
                      <a-text class="t-home-sub-banner-edit__text-field-label" weight="bold"
                        >タグ設定</a-text
                      >
                      <div class="t-home-sub-banner-edit__tag-list">
                        <div
                          v-for="(tag, index) in homeSubBannerData.newTags"
                          :key="index"
                          class="t-home-sub-banner-edit__tag-item"
                        >
                          <m-form-input>
                            <a-apply-text-field
                              :id="'tag-' + index"
                              v-model="homeSubBannerData.newTags[index]"
                              :data-testid="'edit-home-sub-banner-tag-input-new-' + index"
                              type="text"
                              maxlength="10"
                              :placeholder="'タグ' + (index + 1)"
                            />
                          </m-form-input>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-show="activeTab === 'old'"
                    id="t-home-sub-banner-edit-uploading-file"
                    class="t-home-sub-banner-edit__row"
                  >
                    <div class="t-home-sub-banner-edit__col-1">
                      <div class="t-home-sub-banner-edit__fields">
                        <m-form-input>
                          <a-upload-field
                            id="upload-image"
                            v-model="homeSubBannerData.imageFile.file"
                            test-id-text="edit-home-sub-banner-image"
                            name="imageFile"
                            class="t-home-sub-banner-edit-uploading-file__form-upload"
                            label="ファイルをドラッグ＆ドロップするかパソコンからファイルを貼り付けしてください。"
                            accept="image/png, image/jpg, image/jpeg"
                            @change="handleUploadFileChange('imageFile', $event)"
                            @show-error-modal="showErrorModal"
                          />
                        </m-form-input>
                      </div>
                    </div>
                    <div class="t-home-sub-banner-edit__col-2">
                      <div class="t-home-sub-banner-edit__fields">
                        <m-form-input>
                          <a-apply-text-field
                            id="title"
                            v-model="homeSubBannerData.title"
                            data-testid="edit-home-sub-banner-title-input"
                            type="text"
                            maxlength="30"
                            maxlength-id="t-home-sub-banner-edit-title-maxlength"
                            placeholder="タイトル入力"
                          />
                        </m-form-input>
                      </div>
                    </div>
                  </div>
                  <!-- 共通：URL入力エリア -->
                  <div class="t-home-sub-banner-edit__row">
                    <a-text id="t-home-sub-banner-edit-iOSWebsite__a-text">
                      ios側Webサイト&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a-text
                    >
                    <m-form-input>
                      <a-apply-text-field
                        id="t-home-sub-banner-edit-iOS__contents-url"
                        v-model="homeSubBannerData.iosContentsURL"
                        class="t-home-sub-banner-edit__contents-url"
                        :disabled="disabled"
                        data-testid="t-home-sub-banner-edit-iOS-url-input"
                        type="text"
                        maxlength="500"
                        maxlength-id="t-home-sub-banner-edit-iOS__contents-url-maxlength"
                        placeholder="iOS側のURL入力"
                      />
                    </m-form-input>
                  </div>
                  <div class="t-home-sub-banner-edit__row">
                    <a-text id="t-home-sub-banner-edit-androidWebsite__a-text"> android側Webサイト</a-text>
                    <m-form-input>
                      <a-apply-text-field
                        id="t-home-sub-banner-edit-android__contents-url"
                        v-model="homeSubBannerData.androidContentsURL"
                        class="t-home-sub-banner-edit__contents-url"
                        :disabled="disabled"
                        data-testid="t-home-sub-banner-edit-android-url-input"
                        type="text"
                        maxlength="500"
                        maxlength-id="t-home-sub-banner-edit-android__contents-url-maxlength"
                        placeholder="android側のURL入力"
                      />
                    </m-form-input>
                  </div>
                </div>
              </m-action-card>
            </div>
          </m-section>
          <m-section>
            <m-action-card :id="idName[3]" title="公開設定" header-border no-header-margin icon="calendar-setting">
              <div class="t-home-sub-banner-edit__fields">
                <div id="t-home-sub-banner-edit-cast-start-date-day__row" class="t-home-sub-banner-edit__row">
                  <a-text id="t-home-sub-banner-edit-cast-start-date__a-text">公開日</a-text>　
                  <m-form-input id="t-home-sub-banner-edit-cast-start-date-day__form-input">
                    <a-calendar-field
                      id="cast-start-date-day"
                      v-model="homeSubBannerData.castStartDate"
                      test-id-text="edit-home-sub-banner-publish-start"
                      :min-date="minDate"
                      date-placeholder="公開日"
                      time-placeholder="00:00"
                      mode="dateTime"
                      :disabled="hasParentDoc"
                    />
                  </m-form-input>
                </div>
                <div class="t-home-sub-banner-edit__row">
                  <a-text id="t-home-sub-banner-edit-cast-end-date__a-text">公開終了日</a-text>　
                  <m-form-input id="t-home-sub-banner-edit-cast-end-date-day__form-input">
                    <a-calendar-field
                      id="cast-end-date-day"
                      v-model="homeSubBannerData.castEndDate"
                      test-id-text="edit-home-sub-banner-publish-end"
                      :min-date="minDate"
                      date-placeholder="公開終了日"
                      time-placeholder="00:00"
                      mode="dateTime"
                      @change="handleChange"
                    />
                  </m-form-input>
                </div>
              </div>
            </m-action-card>
          </m-section>
          <m-section>
            <m-action-card :id="idName[4]" title="承認フロー" header-border no-header-margin icon="user-setting">
              <div class="t-home-sub-banner-edit__fields__pushtype">
                <m-form-input id="t-home-sub-banner-edit__fields__pushtype">
                  <a-select-field
                    id="t-home-sub-banner-edit__fields__pushtype__a-select-field"
                    v-model="homeSubBannerData.checkStatus"
                    data-testid="detail-home-sub-banner-check-status-select"
                    :options="checkStatusOptions"
                    :v-options="visibleCheckStatusOptions"
                  />
                </m-form-input>
              </div>
              <!-- 情報を表示するために m-data-table を追加します 承認フロー -->
              <m-data-table
                :empty-text="dataTableEmp"
                :fit="true"
                :data="homeSubBannerData.checkHistories"
                id-text="home-sub-banner-check-histories-info-display"
              >
                <a-data-table-column
                  prop="publishedDocumentId"
                  :min-width="120"
                  :label="'公開ドキュメントID：<br>' + docId"
                  align="center"
                >
                  <template #default="scope">
                    <a-text size="medium" :center="true">公開{{ scope.index + 1 }}回目</a-text>
                  </template>
                </a-data-table-column>
                <a-data-table-column prop="draft" :min-width="100" label="下書き" align="center">
                  <template #default="scope">
                    <a-text size="medium" :center="true">{{ scope.row.draft.userName }}</a-text>
                    <a-text size="small" :center="true">{{ scope.row.draft.updateDate }}</a-text>
                  </template>
                </a-data-table-column>
                <a-data-table-column prop="checked" :min-width="100" label="チェック済み" align="center">
                  <template #default="scope">
                    <a-text size="medium" :center="true">{{ scope.row.checked.userName }}</a-text>
                    <a-text size="small" :center="true">{{ scope.row.checked.updateDate }}</a-text>
                  </template>
                </a-data-table-column>
                <a-data-table-column prop="approved" :min-width="100" label="承認済み" align="center">
                  <template #default="scope">
                    <a-text size="medium" :center="true">{{ scope.row.approved.userName }}</a-text>
                    <a-text size="small" :center="true">{{ scope.row.approved.updateDate }}</a-text>
                  </template>
                </a-data-table-column>
              </m-data-table>
            </m-action-card>
          </m-section>
        </div>
        <m-form-action-buttons>
          <a-button
            id="saveBtn"
            data-testid="edit-home-sub-banner-save-button"
            variant="block"
            color="primary"
            submit="submit"
            >保存</a-button
          >
        </m-form-action-buttons>
      </form>
    </div>

    <!-- Info, Erro Modal -->
    <teleport to="body">
      <o-modal
        id="online-shop-serviceCreate_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal--confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span id="online-shop-serviceCreate_resultModal_body" v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            data-testid="error-info-modal-confirm-button"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="handleCloseModal"
          />
        </template>
      </o-modal>
    </teleport>
  </t-default-layout>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AButton from '@/components/atoms/button';
import AUploadField from '@/components/atoms/upload-field';
import AText from '@/components/atoms/text';
import ABackPage from '@/components/atoms/back-page';
import AApplyTextField from '@/components/atoms/apply-text-field';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import TDefaultLayout from '@/components/templates/default-layout';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import ACalendarField from '@/components/atoms/calendar-field';
import { utils } from '@/common/utils.js';
import { useVuelidate } from '@vuelidate/core';
import { homeSubBannerValidation } from '@/validations/homeSubBanner.js';
import { cloneDeep } from 'lodash';

export default {
  name: 't-home-sub-banner-edit',
  components: {
    TDefaultLayout,
    MSection,
    MActionCard,
    AText,
    AButton,
    ABackPage,
    MFormActionButtons,
    AUploadField,
    ACalendarField,
    AApplyTextField,
  },
  mixins: [customRequest, customValidate, messageContent, utils],
  props: {
    class: {
      type: String,
      default: '',
    },
  },

  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  data() {
    return {
      id: this.$route.query.id,
      source: this.$route.query.source,
      show: this.$route.query.show ?? '1',
      idName: [],
      maxPosition: 0,
      minDate: utils.currentDateTime(),
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      activeTab: 'new',
      hasParentDoc: false,
      docId: (() => {
        const id = this.$route.query.id;
        if (id.includes('_')) {
          const lastIndex = id.lastIndexOf('_');
          return id.slice(0, lastIndex);
        }
        return id;
      })(),

      // コンテンツデータ
      homeSubBannerData: {
        title: '', // 旧タイトル用
        newTitle: '', // リニューアル後タイトル
        imageURL: '', //
        imageFile: {
          file: null,
          filename: null,
          binary: null,
          size: null,
        },
        newImageURL: '', // リニューアル後画像の公開URL
        newImageFile: {
          // リニューアル後画像ファイルオブジェクト
          file: null,
          filename: null,
          binary: null,
          size: null,
        },
        newDescription: '', // 新説明文
        newTags: ['', '', '', '', ''], // 新タグ
        position: 0, // 位置表示
        castStartDate: '', // 公開開始日
        castEndDate: '', // 公開終了日
        deleteDate: '', // 削除予定日
        draftFlag: false, // 下書き
        dAccountLoginFlag: false, //ビジネスｄアカウントログインフラグ
        webviewFlag: false, // Webビューフラグ
        notificationPromptFlag: false, // 通知許可フラグ
        checkStatus: 'draft', // チェックステータス
        iosContentsURL: '', // iosコンテンツの遷移先URL
        androidContentsURL: '', // androidコンテンツの遷移先URL
        checkHistories: [
          {
            draft: {
              userName: '',
              updateDate: '',
            },
            checked: {
              userName: '',
              updateDate: '',
            },
            approved: {
              userName: '',
              updateDate: '',
            },
          },
        ],
      },
      isPublished: false, // 公開中かどうかのフラグ
      beforeCastEndDate: '', // 変更前の公開終了日時
      currentCheckStatus: 'draft', // DBに現在のcheckStatus
      checkStatusOptions: [
        { value: 'draft', label: '下書き' },
        { value: 'checked', label: 'チェック済み' },
        { value: 'approved', label: '承認済み' },
      ],
      visibleCheckStatusOptions: [],
    };
  },

  validations() {
    return homeSubBannerValidation.update(this.homeSubBannerData.checkStatus);
  },

  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-home-sub-banner-edit');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  created() {
    for (let i = 1; i <= 4; i++) {
      this.idName[i] = 'h1-home-sub-banner-edit-' + i;
    }
    this.handleGetHomeSubBannerInfo();
    this.getPositionHomeSubBannerList();
  },
  mounted() {},
  methods: {
    async handleFormSubmit() {
      const isFormCorrect = await this.v$.$validate();

      if (!isFormCorrect) {
        let errMsg = '';
        this.v$.$errors.map(item => (errMsg += item.$message + '<br>'));
        this.showErrorModal(errMsg);
        return;
      }

      const payload = cloneDeep(this.homeSubBannerData);
      //  URLに特殊文字　<>'"　を入力するチェックする
      if (messageContent.checkUrlSpecialCharacter(payload.iosContentsURL)) {
        this.showErrorModal(messageContent.urlSpecialCharater);
        return;
      }
      if (messageContent.checkUrlSpecialCharacter(payload.androidContentsURL)) {
        this.showErrorModal(messageContent.urlSpecialCharater);
        return;
      }
      payload.androidContentsURL = encodeURI(payload.androidContentsURL);
      payload.iosContentsURL = encodeURI(payload.iosContentsURL);
      // Note: 「=」はCloudArmorポリシーに抵触するケースがあるためエスケープを行う
      // 新旧両方のデータをFirestoreに保存するため、両方のタイトルと新バナーのdescription/tagsをエスケープ
      payload.title = payload.title.replace(/=/g, '%%eq%%');
      payload.newTitle = payload.newTitle.replace(/=/g, '%%eq%%');
      payload.newDescription = payload.newDescription.replace(/=/g, '%%eq%%');
      payload.newTags = payload.newTags
        .filter(tag => tag && tag.trim() !== '')
        .map(tag => tag.replace(/=/g, '%%eq%%'));

      if (!messageContent.checkHasSpecialCharacterInObj(payload)) {
        this.showErrorModal(messageContent.hasSpecialCharacter);
        return;
      }

      const id = this.id;
      if (id) {
        if (this.homeSubBannerData.castEndDate) {
          const castEndDate = new Date(this.homeSubBannerData.castEndDate);
          const deleteDate = new Date(castEndDate.setFullYear(castEndDate.getFullYear() + 1));
          this.deleteDate = this.convertDateToString(deleteDate);
        }
        const formDataTmp = {
          id: id ?? '',
          title: payload.title ?? '', // 旧タイトル
          newTitle: payload.newTitle ?? '', // 新タイトル
          newDescription: payload.newDescription ?? '', // 新説明文
          newTags: payload.newTags ?? [], // 新タグ
          position: this.maxPosition ?? 0,
          imageFile: this.homeSubBannerData.imageFile.binary ?? '', // 旧画像ファイル
          newImageFile: this.homeSubBannerData.newImageFile.binary ?? '', // 新画像ファイル
          castStartDate: this.homeSubBannerData.castStartDate ?? '',
          castEndDate: this.homeSubBannerData.castEndDate ?? '',
          deleteDate: this.deleteDate ?? '',
          draftFlag: this.homeSubBannerData.draftFlag ?? false,
          dAccountLoginFlag: this.homeSubBannerData.dAccountLoginFlag ?? false,
          webviewFlag: this.homeSubBannerData.webviewFlag ?? false,
          notificationPromptFlag: this.homeSubBannerData.notificationPromptFlag ?? false,
          checkStatus: this.homeSubBannerData.checkStatus ?? 'draft',
          imageURL: this.homeSubBannerData.imageURL ?? '', // 旧画像URL
          newImageURL: this.homeSubBannerData.newImageURL ?? '', // 新画像URL
          iosContentsURL: encodeURI(this.homeSubBannerData.iosContentsURL.replace(/[\s\uFEFF\xA0]/g, '')) ?? '',
          androidContentsURL: encodeURI(this.homeSubBannerData.androidContentsURL.replace(/[\s\uFEFF\xA0]/g, '')) ?? '',
          checkHistories: this.homeSubBannerData.checkHistories ?? [],
        };
        await this.postRequest('/home-sub-banner/edit', formDataTmp).then(res => {
          if (res.status === 'success') {
            this.$router.push({ name: 'HomeSubBanner', query: { show: this.show } });
          } else {
            if (res.message) {
              this.showErrorModal(res.message);
            } else {
              this.showErrorModal(messageContent.requireTry('小バナー更新'));
            }
          }
        });
      } else {
        this.showErrorModal(messageContent.requireTry('ショップ（人気のサービス更新'));
      }
    },
    handleUploadFileChange(key, fileList) {
      // key に基づいて対象のオブジェクトを取得
      const fileObj = this.homeSubBannerData[key];
      const reader = new FileReader();
      reader.addEventListener(
        'load',
        () => {
          // eslint-disable-next-line no-unused-vars
          const [info, content] = reader.result.split(',');
          fileObj.binary = content;
        },
        false
      );
      if (fileList && fileList[0]) {
        reader.readAsDataURL(fileList[0]);
        fileObj.filename = fileList[0].name;
        fileObj.size = fileList[0].size;
      } else {
        // Clear file content
        fileObj.file = null;
        fileObj.filename = null;
        fileObj.binary = null;
        fileObj.size = null;
        if (key === 'imageFile') {
          this.homeSubBannerData.imageURL = '';
        } else if (key === 'newImageFile') {
          this.homeSubBannerData.newImageURL = '';
        }
      }
    },
    getPositionHomeSubBannerList: function () {
      const data = {
        execUserID: this.execUserID,
      };
      return this.postRequest('/home-sub-banner/get-list', data).then(response => {
        let maxPosition = 0;
        const nowDate = utils.currentDateTime();
        for (const k in response.data) {
          const deleteDate = response.data[k].deleteDate;
          const checkStatus = response.data[k].checkStatus;
          if (checkStatus === 'approved' && deleteDate > nowDate) {
            maxPosition = Math.max(maxPosition, response.data[k].position);
          }
        }
        maxPosition++;
        this.maxPosition = maxPosition;
        return maxPosition;
      });
    },
    handleGetHomeSubBannerInfo() {
      const nowDate = utils.currentDateTime();
      const id = this.$route.query.id;
      if (id) {
        this.postRequest('/home-sub-banner/get', { id })
          .then(e => {
            if (e.status === 'success' && e.data) {
              const data = e.data;
              const authInfo = this.$store.state.user.authInfo;
              if (authInfo === 'manager') {
                this.homeSubBannerData.title = (data?.title || '').replace(/%%eq%%/g, '=');
                this.homeSubBannerData.newTitle = (data?.newTitle || '').replace(/%%eq%%/g, '=');
                this.homeSubBannerData.newDescription = (data?.newDescription || '').replace(/%%eq%%/g, '=');

                // タグのデコードと5枠へのマッピング
                const rawTags = data?.newTags || [];
                this.homeSubBannerData.newTags = ['', '', '', '', ''].map((_, i) =>
                  (rawTags[i] || '').replace(/%%eq%%/g, '=')
                );

                this.homeSubBannerData.newImageURL = data?.newImageURL || '';
                this.homeSubBannerData.newImageFile = { file: e.data.newImageURL ? e.data.newImageURL : null };
                this.homeSubBannerData.imageURL = data?.imageURL || '';
                this.homeSubBannerData.imageFile = { file: e.data.imageURL ? e.data.imageURL : null };

                this.homeSubBannerData.dAccountLoginFlag = data?.dAccountLoginFlag || false;
                this.homeSubBannerData.webviewFlag = data?.webviewFlag || false;
                this.homeSubBannerData.notificationPromptFlag = data?.notificationPromptFlag ?? false;
                this.homeSubBannerData.castStartDate = data?.castStartDate || '';
                this.homeSubBannerData.castEndDate = data?.castEndDate || '';
                this.homeSubBannerData.iosContentsURL = decodeURI(data?.iosContentsURL) || '';
                this.homeSubBannerData.androidContentsURL = decodeURI(data?.androidContentsURL) || '';
                // 変更前の公開終了日時を保存
                this.beforeCastEndDate = data?.castEndDate || '';
                // 公開中の投稿か確認
                if (
                  data &&
                  data.checkStatus === 'approved' &&
                  data.castStartDate &&
                  data.castEndDate &&
                  data.castStartDate <= nowDate &&
                  nowDate <= data.castEndDate
                ) {
                  this.isPublished = true;
                  this.minDate = '';
                }

                if (this.isPublished) {
                  this.$router.push({ name: 'HomeSubBanner' });
                  return;
                }

                this.hasParentDoc = data?.parentDocId ? true : false;

                // DBに現在のcheckStatusを保存
                this.currentCheckStatus = data?.checkStatus;
                // 現在のcheckStatusの値しだいでvisibleCheckStatusOptionsを変更する
                this.visibleCheckStatusOptions = this.selectVisibleCheckStatusOptions(data?.checkStatus || '');
                // DBから取得したcheckHistoriesが空配列のときは更新せず、初期値のcampaignData.checkHistoriesを用いる
                if (data?.checkHistories && data?.checkHistories.length > 0) {
                  this.homeSubBannerData.checkHistories = data?.checkHistories;
                }
              } else {
                this.$router.push({ name: 'PermissionDenied' });
                return;
              }
            } else {
              this.showErrorModal(messageContent.requireTry('小バナー 取得'));
            }
          })
          .catch(error => {
            console.error(error);
            this.showErrorModal(messageContent.requireTry('小バナー 取得'));
          });
      }
    },
    handleCancelClick() {
      const id = this.id;
      const source = this.source;
      if (id && source === 'detail') {
        return this.$router.push({ name: 'HomeSubBannerDetail', query: { id: id, show: this.show } });
      } else {
        return this.$router.push({ name: 'HomeSubBanner', query: { show: this.show } });
      }
    },
    selectVisibleCheckStatusOptions(checkStatus) {
      if (checkStatus === 'draft') {
        return [
          { value: 'draft', label: '下書き' },
          { value: 'checked', label: 'チェック済み' },
        ];
      } else if (checkStatus === 'checked') {
        return [
          { value: 'draft', label: '下書き' },
          { value: 'approved', label: '承認済み' },
        ];
      } else if (checkStatus === 'approved') {
        return [{ value: 'draft', label: '下書き' }];
      }
      // イレギュラーは下書き相当
      return [
        { value: 'draft', label: '下書き' },
        { value: 'checked', label: 'チェック済み' },
      ];
    },
    backPageName() {
      const source = this.source;
      if (source === 'detail') {
        return '詳細画面';
      } else {
        return '一覧画面';
      }
    },
    backPage() {
      const source = this.source;
      if (source === 'detail') {
        return 'HomeSubBannerDetail';
      } else {
        return 'HomeSubBanner';
      }
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
  },
};
</script>
